var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.235,
    height: 30.25,
    viewBox: "0 0 30.235 30.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_instagram",
    "data-name": "vuesax/bold/instagram",
    transform: "translate(-299.994 -443.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(299.993 443.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.462,0H8.788C3.282,0,0,3.282,0,8.788v12.66c0,5.521,3.282,8.8,8.788,8.8h12.66c5.505,0,8.788-3.282,8.788-8.788V8.788C30.25,3.282,26.968,0,21.462,0ZM15.125,20.993a5.868,5.868,0,1,1,5.868-5.868A5.874,5.874,0,0,1,15.125,20.993ZM24.079,7.381a1.747,1.747,0,0,1-.318.5,1.746,1.746,0,0,1-.5.318,1.5,1.5,0,0,1-1.649-.318,1.747,1.747,0,0,1-.318-.5,1.426,1.426,0,0,1,0-1.149,1.561,1.561,0,0,1,.318-.5,1.51,1.51,0,0,1,1.361-.408.912.912,0,0,1,.287.091,1.145,1.145,0,0,1,.272.136,2.383,2.383,0,0,1,.227.181,1.561,1.561,0,0,1,.318.5,1.426,1.426,0,0,1,0,1.149Z",
    transform: "translate(0 0)",
    fill: "#dd2a7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H30.223V30.223H0Z",
    transform: "translate(30.235 30.236) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.429b52a8e7e35121fcefde99dc6928c7.svg";
export { ForwardRef as ReactComponent };